const paths = [
  {
    num: 1,
    title: 'Foundation & Awareness',
    items: [
      'Identify your real energy limits and learn your current true baseline.',
      'Map your push-crash triggers.',
      'Build your personal safety net and start daily tracking.',
    ],
  },
  {
    num: 2,
    title: 'Breaking the Push-Crash Cycle',
    items: [
      'Spot the subtle "yellow zone" and overcome internal resistance; stop trying to "earn" your rest and treat it as a mandatory biological requirement.',
      'Apply the 5-minute pause tool.',
      'Use the minimal recovery frame.',
    ],
  },
  {
    num: 3,
    title: 'Structure & Rhythm',
    items: [
      'Design your day before it begins; shift from response to strategy.',
      'Visualise capacity with Spoon Theory.',
      'Apply the rule of three constraints and place strategic, preventative pauses.',
    ],
  },
  {
    num: 4,
    title: 'Resilience & Recovery',
    items: [
      'Add background energy drifts into the nervous system.',
      'Use the Protectometer tool.',
      'Recognise hidden relational costs and implement micro-reductions.',
    ],
  },
  {
    num: 5,
    title: 'Integration & Consistency',
    items: [
      'Catch the patterns of "drift" before structure dissolves.',
      'Build a minimum effective structure and ditch the all-or-nothing reset mindset.',
      'Utilise the continuity loop to keep moving through disruption.',
    ],
  },
];

export default function PathsSection() {
  return (
    <section id="whats-inside" className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          alt="Soft airy botanical background"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Very%20soft%20pale%20white%20and%20light%20gray%20background%20with%20delicate%20airy%20eucalyptus%20leaves%20and%20fern%20branches%2C%20minimalist%20botanical%20composition%2C%20subtle%20watercolor%20style%2C%20gentle%20diffused%20light%2C%20calming%20wellness%20aesthetic%2C%20muted%20sage%20and%20soft%20silver%20tones%2C%20editorial%20photography%2C%20serene%20peaceful%20atmosphere&width=1600&height=900&seq=course-paths-01&orientation=landscape"
        />
        <div className="absolute inset-0 bg-white/75" />
      </div>

      <div className="relative z-10 section-padding max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-3">
            What&apos;s Inside
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Five structured Energy Paths that move you from awareness to sustainable, everyday change.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {paths.map((path) => (
            <div
              key={path.num}
              className="bg-[#6B8FA3]/90 backdrop-blur-sm border border-[#5A7F94]/40 rounded-xl p-6 shadow-lg hover:shadow-xl hover:border-white/30 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 text-white text-sm font-bold">
                  {path.num}
                </span>
                <h3 className="font-heading text-base font-semibold text-white">
                  {path.title}
                </h3>
              </div>
              <ul className="space-y-2.5">
                {path.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-white/80 leading-relaxed">
                    <span className="mt-1 w-3.5 h-3.5 flex items-center justify-center shrink-0">
                      <i className="ri-checkbox-circle-line text-xs text-white/70" />
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}